import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import TableEmptyState from "./TableEmptyState.jsx";
import TableRow from "./TableRow.jsx";

const TableBodyRows = ({
  items,
  renderRow,
  getItemKey,
  getRowClassName,
  rowProps,
  rowContext,
}) => {
  return items.map((item, index) => {
    const key = getItemKey(item, index);
    const resolvedRowProps = rowProps ? rowProps(item, index) || {} : {};

    return (
      <TableRow
        key={key}
        data-row-key={String(key)}
        className={getRowClassName ? getRowClassName(item, index) : ''}
        {...resolvedRowProps}
      >
        {renderRow(item, index, rowContext)}
      </TableRow>
    );
  });
};

const TableBody = ({
  items = [],
  renderRow,
  getItemKey,
  columnsCount,
  emptyMessage,
  draggable = false,
  droppableId = 'common-table',
  onDragEnd,
  getRowClassName,
  rowProps,
  rowContext,
}) => {
  if (!items.length) {
    return (
      <tbody className="common-table__body">
        <TableEmptyState colSpan={columnsCount} message={emptyMessage} />
      </tbody>
    );
  }

  if (!draggable) {
    return (
      <tbody className="common-table__body">
        <TableBodyRows
          items={items}
          renderRow={renderRow}
          getItemKey={getItemKey}
          getRowClassName={getRowClassName}
          rowProps={rowProps}
          rowContext={rowContext}
        />
      </tbody>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId} direction="vertical">
        {(provided) => (
          <tbody
            className="common-table__body"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {items.map((item, index) => {
              const key = getItemKey(item, index);
              const resolvedRowProps = rowProps ? rowProps(item, index) || {} : {};

              return (
                <Draggable key={key} draggableId={String(key)} index={index}>
                  {(draggableProvided) => (
                    <TableRow
                      innerRef={draggableProvided.innerRef}
                      data-row-key={String(key)}
                      className={getRowClassName ? getRowClassName(item, index) : ''}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                      {...resolvedRowProps}
                    >
                      {renderRow(item, index, rowContext)}
                    </TableRow>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </tbody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default TableBody;
